export const BASE_URL = 'cost-centers';

export const PATHS = {
  BASE_URL,
};

export const COST_CENTERS_LIST_VIEW_STORAGE_KEY = 'costCentersListView';

export const COST_CENTER_CODE_MAX_LENGTH = 64;
export const COST_CENTER_NAME_MAX_LENGTH = 200;
